enum TraceDivisionType {
    SYSTEM,
    CUSTOM,
}

export default TraceDivisionType;
